<template>
  <ol v-if="hasBreadcrumbs" class="breadcrumbs" aria-label="breadcrumb">
    <template v-for="(crumb, index) in breadcrumbs">
      <li v-if="Array.isArray(crumb.items)" class="item dropdown">
        <button class="dropdown-toggle arrow" type="button" :id="`breadcrumbMenuButton${index}`" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{currentBreadcrumbText(crumb.items)}}
        </button>
        <div class="dropdown-menu" :aria-labelledby="`breadcrumbMenuButton${index}`">
          <a v-for="item in crumb.items" :href="item.url" class="dropdown-item" :class="dropdownItemClasses(item)">{{item.text}}</a>
        </div>
        <span>{{crumb.text}}</span>
      </li>
      <li v-else-if="crumb.url" class="item">
        <a v-if="!isDisabled" :href="crumb.url">{{crumb.text}}</a>
        <span v-else>{{crumb.text}}</span>
      </li>
      <li v-else class="item">
        <span>{{crumb.text}}</span>
      </li>
    </template>
  </ol>
</template>

<script lang="ts">
  import Vue from "vue";
  import IBreadcrumb from "../interfaces/breadcrumbInterfaces";
  import {Hash} from "../interfaces/hashInterfaces";

  export default Vue.extend({
    props: {
      breadcrumbs: {
        type: Array as () => IBreadcrumb[],
        default: () => {
          return [];
        }
      }
    },
    data: function () {
      return {};
    },
    computed: {
      hasBreadcrumbs(): boolean {
        return this.breadcrumbs.length > 0;
      },
      isDisabled(): boolean {
        return window.location.pathname.includes('edit') && window.location.pathname.includes('detail_views')
      },
    },
    methods: {
      currentBreadcrumbPage(url: string): boolean {
        return window.location.pathname === url || window.location.href === url;
      },
      currentBreadcrumbText(items: IBreadcrumb[]): string {
        const current_item = items.find(i => this.currentBreadcrumbPage(i.url)) || items[0];
        return current_item.text;
      },
      dropdownItemClasses(item: IBreadcrumb): Hash<boolean> {
        return {
          active: this.currentBreadcrumbPage(item.url),
        }
      }
    }
  });
</script>